

import { Vue, Component, Prop } from 'vue-property-decorator'
import AppLink from '~/components/shared/app-link.vue'

@Component({
    components: { AppLink },
})
export default class BlockBanner extends Vue {
    @Prop({ type: Object, default: () => {}}) readonly banner!: any

    image (banner) {
        if (banner) {
            const { id, bannerimg } = banner
            return (id && bannerimg) ? `url(${this.$url.image('headerbanners', id, bannerimg)})` : "https://via.placeholder.com/1110x450.png"
        }
    }

    redirectToPage () {
        if (this.banner.btnurl != "") {
            window.open(this.banner.btnurl, "_blank")
        }
    }
}

